import { InjectionToken } from '@angular/core';
import type { Auth } from 'firebase/auth';

/**
 * Token de injeção da instância do Firebase Auth.
 *
 * Substitui o token `Auth` do @angular/fire pelo SDK `firebase` puro, permitindo
 * remover a dependência @angular/fire (que não possui versão para Angular 22).
 * Fica em uma lib compartilhada porque é consumido tanto pelo app quanto pela lib
 * de subscription. O provider é registrado no app (`provideFirebase`), pois
 * depende do environment.
 */
export const FIREBASE_AUTH = new InjectionToken<Auth>('FIREBASE_AUTH');
